import { setActiveTrace } from '@atlaskit/react-ufo/experience-trace-id-context';
import { getMeta } from '@atlassian/help-center-common-util/meta';

let alreadySet = false;

export const retrieveAndSetPageLoadTrace = () => {
    if (__SERVER__ || alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention

    alreadySet = true;

    setActiveTrace(traceId, spanId, 'page_load');
};
